import { type MessageDescriptor } from 'react-intl';

import { type RovoResponseTone } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { personalityThinkingVerbMessages } from './messages';

// Message keys are `<tonePrefix><n>`; grouping by prefix yields each set. The
// tone prefixes are mutually non-overlapping, so `startsWith` is unambiguous.
const pick = (prefix: string): MessageDescriptor[] =>
	Object.entries(personalityThinkingVerbMessages)
		.filter(([key]) => key.startsWith(prefix))
		.map(([, descriptor]) => descriptor);

/**
 * Content-design thinking-indicator verb sets keyed by preset. Every preset —
 * including `rovo_default` — has a set; selection picks one per thinking spell
 * (see `usePersonalityThinkingVerb`). Applied only behind the personality
 * thinking-verb gate, so gate-off keeps the plain "Rovo is thinking" baseline.
 */
export const THINKING_VERB_SETS: Record<RovoResponseTone, MessageDescriptor[]> = {
	rovo_default: pick('rovoDefault'),
	professional: pick('professional'),
	creative: pick('creative'),
	empathetic: pick('empathetic'),
};
